/* eslint-disable camelcase */
import { Tag } from 'antd'
import { IPolicy, ISectionFeature } from 'types/interfaces'

import austbrokerExpressCoverLogo from 'assets/images/austbroker_express_cover_logo.png'
import bizcoverFlagLogo from 'assets/images/bizcover-flag.jpg'

import './status-tag.less'

interface StatusTagProps {
  color?: string
  text?: string
  policy?: IPolicy
  section?: ISectionFeature
}

const StatusTag: React.FC<StatusTagProps> = ({ color, text, policy, section }) => {
  if (policy) {
    const { sections, is_new, is_pending, is_archived, is_expired, is_express_cover, is_bizcover } =
      policy

    if (is_archived || is_expired) {
      return <Tag color='red'>Expired</Tag>
    }

    return (
      <>
        {is_express_cover && (
          <span className='logo-container'>
            <img className='logo' src={austbrokerExpressCoverLogo} alt='Austbroker Express Cover' />
          </span>
        )}
        {is_bizcover && (
          <span className='logo-container'>
            <img className='logo' src={bizcoverFlagLogo} alt='Austbroker Bizcover' />
          </span>
        )}
        {sections?.some((section) => !section.is_approved) && (
          <Tag color='yellow'>awating preview</Tag>
        )}
        {!is_expired && is_new && <Tag color='cyan'>New</Tag>}
        {is_pending && <Tag color='orange'>Pending</Tag>}
      </>
    )
  }

  if (section) {
    const { is_most_popular, is_summary, is_water_perils, is_training } = section

    return (
      <>
        {is_most_popular && <Tag color='green'>essential</Tag>}
        {is_water_perils && <Tag color='cyan'>water perils</Tag>}
        {is_summary && <Tag color='magenta'>key selling</Tag>}
        {is_training && <Tag color='orange'>training</Tag>}
      </>
    )
  }

  return <Tag color={color}>{text}</Tag>
}

export default StatusTag
